import Vue from 'vue'
import Vuex from 'vuex'
import scheduler from './scheduler'
import { entitlements } from 'pp-vuex-web-services'
import practice from './practice'
import { APPOINTMENT_TYPE_DROP_IN } from '@/constants'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    appointmentType: APPOINTMENT_TYPE_DROP_IN
  },
  getters: {
    appointmentType: state => state.appointmentType
  },
  mutations: {
    SET_APPOINTMENT_TYPE (state, appointmentType) {
      state.appointmentType = appointmentType
    }
  },
  actions: {
    setAppointmentType ({ commit }, appointmentType) {
      commit('SET_APPOINTMENT_TYPE', appointmentType)
    }
  },
  modules: {
    entitlements,
    scheduler,
    practice
  }
})

const setupWebServices = () => {
  store.commit('entitlements/SET_ENTITLEMENT_CONFIG_SERVICE_API_KEY', process.env.VUE_APP_ENTITLEMENT_CONFIG_SERVICE_API_KEY)
  store.commit('entitlements/SET_ENTITLEMENT_CONFIG_SERVICE_DOMAIN', process.env.VUE_APP_ENTITLEMENT_CONFIG_SERVICE_DOMAIN)
}

setupWebServices()

export default store
